import React from 'react';
import { HeadCellImplementationProps } from '../KeywordTable/HeadCells/models';
import HeadCellSortOptions from './HeadCellSortOptions';
import VoxelMenuDivider from '../../../voxel/PopoverMenu/VoxelMenuDivider';
import VoxelPopoverMenuItem from '../../../voxel/PopoverMenu/VoxelPopoverMenuItem';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/pro-regular-svg-icons';

export interface HeadCellStandardOptionsProps extends HeadCellImplementationProps {
  noDivider?: boolean;
}

export const HeadCellStandardOptions: React.FC<HeadCellStandardOptionsProps> = ({
  basicConfig,
  basicState,
  noDivider = false,
}) => {
  return (
    <>
      {!basicConfig.hideColumnDisabled && (
        <>
          <VoxelPopoverMenuItem
            icon={<FontAwesomeIcon icon={faEye} />}
            title="Hide column"
            onClick={basicState.hideColumn}
          />
          {!noDivider && <VoxelMenuDivider />}
        </>
      )}
      <HeadCellSortOptions basicConfig={basicConfig} basicState={basicState} />
      {basicConfig.showSorting && !noDivider && <VoxelMenuDivider />}
    </>
  );
};

export default HeadCellStandardOptions;
